import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSoftwareRenewalHistory } from "../lib/software";

export default function SoftwareRenewalHistory() {
  const { id } = useParams();
  const [history, setHistory] = useState([]);

  useEffect(() => {
    getSoftwareRenewalHistory(id).then((res) => setHistory(res.data || []));
  }, [id]);

  return (
    <div>
      <h2>Software Renewal History</h2>

      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Old Expiry</th>
            <th>New Expiry</th>
            <th>Renewal Price</th>
            <th>Invoice</th>
          </tr>
        </thead>
        <tbody>
          {history.map((h) => (
            <tr key={h._id}>
              <td>{new Date(h.oldEndDate).toDateString()}</td>
              <td>{new Date(h.newEndDate).toDateString()}</td>
              <td>₹ {h.renewalPrice}</td>
              <td>{h.invoiceNo}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
